import { makeCompositeId } from '@cbridge-utils/formatters';
import { IMarkupProfile } from '@cbridge-packages/markup-profile';
import { IMarkup } from '../markup.interface';

export const makeMarkupSymbolCompositeId = (profileId: IMarkupProfile['markupProfileId'], symbolId: IMarkup['symbolId']) => (
  makeCompositeId([profileId, symbolId])
);
